import React from 'react';
import ExportPage from './export/ExportPage';

const TicketExport: React.FC = () => <ExportPage area="tickets" />;

export default TicketExport;
